import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../../../store";
import MobileTableStack from "../../base/MobileTableStack";
import { fetchUsers } from "../../../slices/user";
import { UserRoles } from "../../../helpers/checkRole";

interface Props {
  handleEdit?: (id: number) => void;
  handleAdminRoute?: (id: number) => void;
}

const UsersStack: React.FC<Props> = (props) => {
  const { handleEdit, handleAdminRoute } = props;

  const dispatch = useDispatch();
  const { userList } = useSelector((store) => store.users);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const dataRows =
    userList &&
    userList.map((user) => {
      let rowObject = {
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        roles: user.roles
          ?.filter(
            (x) =>
              x.id === UserRoles.GlobalAdmin ||
              x.id === UserRoles.DetectorAdmin ||
              x.id === UserRoles.DetectorUser
          )
          .map((r) => r.value)
          .join(", ")
          .toString(),
        dashboard: !!user.dashboard
          ? `${user.dashboard?.value} (${user.dashboard?.id})`
          : "",
      };

      return rowObject;
    });

  const headers = ["name", "email", "roles", "dashboard"];

  return dataRows?.length ? (
    <MobileTableStack
      rows={dataRows!}
      headers={headers}
      handleEdit={handleEdit}
      handleAdminRoute={handleAdminRoute}
    />
  ) : (
    <></>
  );
};

export default UsersStack;
